import type { OrderComplete } from '@/features/orders/domain/model/order';

export function createMockOrder(orderNumber = '999'): OrderComplete {
  const now = new Date().toISOString();

  return {
    id: `mock-order-test-${Date.now()}`,
    number: orderNumber,
    cash_num: 999,
    sort_id: 999,
    status: 'pending',
    total: 3500,
    is_take_away: false,
    language: 'es',
    comments: '',
    created_at: now,
    updated_at: now,
    location_id: 'mock-location',
    totem_id: 'mock-totem',
    payment_id: 'mock-payment-1',
    locations: {
      id: 'mock-location',
      slug: 'showroom-order-fast',
      name: 'Showroom Order Fast',
    },
    order_items: [
      {
        id: 'item-1',
        order_id: 'mock-order-test',
        product_id: 'mock-prod-1',
        quantity: 1,
        comment: 'Sin cebolla',
        created_at: now,
        products: {
          id: 'mock-prod-1',
          price: 2500,
          product_translations: [
            {
              id: 't-1',
              name: 'Hamburguesa Doble Queso (TEST)',
            },
          ],
        },
        order_sub_selection: [],
      },
      {
        id: 'item-2',
        order_id: 'mock-order-test',
        product_id: 'mock-prod-2',
        quantity: 1,
        comment: '',
        created_at: now,
        products: {
          id: 'mock-prod-2',
          price: 1000,
          product_translations: [
            {
              id: 't-2',
              name: 'Papas Fritas Medianas (TEST)',
            },
          ],
        },
        order_sub_selection: [],
      },
    ],
    order_payments: {
      id: 'mock-payment-1',
      status: 'completed',
      payment_method_id: 'mock-pm-cash',
      metadata: null,
      payment_methods: {
        id: 'mock-pm-cash',
        name: 'Efectivo (Prueba)',
        type: 'efectivo',
        created_at: now,
        deleted_at: null,
        disabled_at: null,
        integration_id: null,
        invoice: true,
        location_id: 'mock-location',
        surcharge: 0,
      },
    },
    totems: {
      id: 'mock-totem',
      name: 'Caja - Showroom Order Fast',
      slug: 'caja-showroom-order-fast',
      web: false,
      printer: null,
    },
    order_discounts: null,
    afip_order: null,
  } as unknown as OrderComplete;
}
